export const amenitiesQueryKeys = {
  all: ['amenities'] as const,
  lists: () => [...amenitiesQueryKeys.all, 'list'] as const,
  list: (filters: object) =>
    [...amenitiesQueryKeys.lists(), { filters }] as const,
};
